// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.spinnermodal_container_spinnermodal__LUJya {
    max-width: 100%;
    display: flexbox;
    flex: 8 1;
    flex-direction: column;
    align-items: flex-start;
    align-content: center;
    justify-content: center;
    border-left: solid 1.5px;
}

.spinnermodal_container_row__cQZYi {
    display: flex;
    flex: 1 1;
    justify-content: space-between;
    flex-direction: column;
    align-content: center;
    align-items: center;
    align-self: center;
}

.spinnermodal_modal__OTOsK {
    position: fixed;
    /* Stay in place */
    z-index: 1;
    /* Sit on top */
    left: 0;
    top: 0;
    width: 100%;
    /* Full width */
    height: 100%;
    /* Full height */
    background-color: rgba(0, 0, 0, 0.4);
    /* Semi-transparent black background */
    display: flex;
    justify-content: center;
    align-items: center;
}

/* Modal Content */
.spinnermodal_modal_content__Hp-DU {
    margin: auto;
    padding: 20px;
    border: 1px solid #888;
    border-radius: 5px;
    display: flex;
    align-items: center;
    box-shadow: 0 5px 8px 0 rgba(0, 0, 0, 0.2);
    background-color: #fefefe;
}

.spinnermodal_modal_text__tb0L6 {
    margin-left: 14px;
    font-size: 24px;
}

/* Create the circle loader with pure CSS */
.spinnermodal_loader__Sa-yr {
    width: 50px;
    height: 50px;
    /* border: 8px solid #ddd; */
    border-left: 8px solid var(--hsrcYellow);
    border-right: 8px solid var(--hsrcYellow);
    /* border-top: 8px solid #2196f3; */
    border-top: 8px solid var(--hsrcYellow);
    /* border-bottom: 8px solid #2196f3; */
    border-bottom: 8px solid var(--hsrcMidBlue);
    border-radius: 50%;
    animation: spinnermodal_spin__A7roI 2s linear infinite;
}

@keyframes spinnermodal_spin__A7roI {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}`, "",{"version":3,"sources":["webpack://./src/components/SpinnerModal/spinnermodal.module.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,gBAAgB;IAChB,SAAO;IACP,sBAAsB;IACtB,uBAAuB;IACvB,qBAAqB;IACrB,uBAAuB;IACvB,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,SAAO;IACP,8BAA8B;IAC9B,sBAAsB;IACtB,qBAAqB;IACrB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,UAAU;IACV,eAAe;IACf,OAAO;IACP,MAAM;IACN,WAAW;IACX,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,oCAAoC;IACpC,sCAAsC;IACtC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA,kBAAkB;AAClB;IACI,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,0CAA0C;IAC1C,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;IACjB,eAAe;AACnB;;AAEA,2CAA2C;AAC3C;IACI,WAAW;IACX,YAAY;IACZ,4BAA4B;IAC5B,wCAAwC;IACxC,yCAAyC;IACzC,mCAAmC;IACnC,uCAAuC;IACvC,sCAAsC;IACtC,2CAA2C;IAC3C,kBAAkB;IAElB,sDAAkC;AACtC;;AAYA;IACI;QACI,uBAAuB;IAC3B;;IAEA;QACI,yBAAyB;IAC7B;AACJ","sourcesContent":[".container_spinnermodal {\r\n    max-width: 100%;\r\n    display: flexbox;\r\n    flex: 8;\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n    align-content: center;\r\n    justify-content: center;\r\n    border-left: solid 1.5px;\r\n}\r\n\r\n.container_row {\r\n    display: flex;\r\n    flex: 1;\r\n    justify-content: space-between;\r\n    flex-direction: column;\r\n    align-content: center;\r\n    align-items: center;\r\n    align-self: center;\r\n}\r\n\r\n.modal {\r\n    position: fixed;\r\n    /* Stay in place */\r\n    z-index: 1;\r\n    /* Sit on top */\r\n    left: 0;\r\n    top: 0;\r\n    width: 100%;\r\n    /* Full width */\r\n    height: 100%;\r\n    /* Full height */\r\n    background-color: rgba(0, 0, 0, 0.4);\r\n    /* Semi-transparent black background */\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n\r\n/* Modal Content */\r\n.modal_content {\r\n    margin: auto;\r\n    padding: 20px;\r\n    border: 1px solid #888;\r\n    border-radius: 5px;\r\n    display: flex;\r\n    align-items: center;\r\n    box-shadow: 0 5px 8px 0 rgba(0, 0, 0, 0.2);\r\n    background-color: #fefefe;\r\n}\r\n\r\n.modal_text {\r\n    margin-left: 14px;\r\n    font-size: 24px;\r\n}\r\n\r\n/* Create the circle loader with pure CSS */\r\n.loader {\r\n    width: 50px;\r\n    height: 50px;\r\n    /* border: 8px solid #ddd; */\r\n    border-left: 8px solid var(--hsrcYellow);\r\n    border-right: 8px solid var(--hsrcYellow);\r\n    /* border-top: 8px solid #2196f3; */\r\n    border-top: 8px solid var(--hsrcYellow);\r\n    /* border-bottom: 8px solid #2196f3; */\r\n    border-bottom: 8px solid var(--hsrcMidBlue);\r\n    border-radius: 50%;\r\n    -webkit-animation: spin 2s linear infinite;\r\n    animation: spin 2s linear infinite;\r\n}\r\n\r\n@-webkit-keyframes spin {\r\n    0% {\r\n        -webkit-transform: rotate(0deg);\r\n    }\r\n\r\n    100% {\r\n        -webkit-transform: rotate(360deg);\r\n    }\r\n}\r\n\r\n@keyframes spin {\r\n    0% {\r\n        transform: rotate(0deg);\r\n    }\r\n\r\n    100% {\r\n        transform: rotate(360deg);\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container_spinnermodal": `spinnermodal_container_spinnermodal__LUJya`,
	"container_row": `spinnermodal_container_row__cQZYi`,
	"modal": `spinnermodal_modal__OTOsK`,
	"modal_content": `spinnermodal_modal_content__Hp-DU`,
	"modal_text": `spinnermodal_modal_text__tb0L6`,
	"loader": `spinnermodal_loader__Sa-yr`,
	"spin": `spinnermodal_spin__A7roI`
};
export default ___CSS_LOADER_EXPORT___;
